import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { SolutionPageComponent } from './solution-page.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatSnackBarModule,
    TranslateModule,
  ],
  declarations: [SolutionPageComponent],
  exports: [SolutionPageComponent],
})
export class SolutionPageModule {}
